import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {EventRSVPStatus, useSetAttendance} from '../../../hooks/useEvent';
import RSVPButton, {RSVPButtonProps} from './RSVPButton';
import RSVPSelect, {RSVPSelectProps} from './RSVPSelect';
import RSVPRestrictionModal from './RSVPRestrictionModal';

interface RSVPControllerProps extends RSVPButtonProps, RSVPSelectProps {
  buttonClickCallback?: () => void;
  optionClickCallback?: () => void;
}

const RSVPController = ({
  event,
  optionClickCallback,
  buttonClickCallback,
  ...props
}: RSVPControllerProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isRestrictionModalOpen, setIsRestrictionModalOpen] = useState(false);
  const {mutateAsync} = useSetAttendance();
  const navigate = useNavigate();
  const currentStatus = event.rsvp_status.status_value || EventRSVPStatus.NO_STATUS;

  // Check if user can RSVP to this event (undefined means we haven't loaded the data yet, treat as true)
  const canRsvp = event.can_rsvp !== false;

  const onClickRSVPButton = (e) => {
    buttonClickCallback && buttonClickCallback();
    e.preventDefault();
    
    // If user cannot RSVP due to membership restrictions, show upgrade modal
    if (!canRsvp && event.rsvp_restriction_reason === 'local_insiders_membership_required') {
      setIsRestrictionModalOpen(true);
      return;
    }
    
    setIsOpen(true);
  };

  const onClickRSVPOption = (status: EventRSVPStatus) => {
    optionClickCallback && optionClickCallback();
    setIsOpen(false);
    mutateAsync({
      eventId: event.id,
      prevStatus: currentStatus,
      status,
    });
  };

  const onCloseRSVPSelect = () => setIsOpen(false);
  
  const onCloseRestrictionModal = () => setIsRestrictionModalOpen(false);
  
  const onUpgradeClick = () => {
    setIsRestrictionModalOpen(false);
    navigate('/memberships');
  };

  return (
    <>
      <RSVPButton event={event} onButtonClick={onClickRSVPButton} {...props} />
      <RSVPSelect
        event={event}
        onModalClose={onCloseRSVPSelect}
        openModal={isOpen}
        onOptionClick={onClickRSVPOption}
        {...props}
      />
      <RSVPRestrictionModal
        isOpen={isRestrictionModalOpen}
        onClose={onCloseRestrictionModal}
        onUpgradeClick={onUpgradeClick}
      />
    </>
  );
};

export default RSVPController;
